import PatientListV2 from "./PatientListV2";
import PatientEmailLogs from "./PatientEmailLogs";
import { useState } from "react";

function PIList(props) {
    const { screenSize, etList, cetList, getSuggestedPrograms, SetModalProperties } = props;
    const [activeTab, setActiveTab] = useState("discharged"); // discharged, email-logs

    const handleTabChange = (e) => {
        setActiveTab(e.target.dataset.name);
    }

    return (
        <div id="pi-list">
            <div id="pi-l-header">
                <h4 className={`${activeTab == "discharged" && "active"}`} onClick={handleTabChange} data-name="discharged">Discharged Patients</h4>
                <h4 className={`${activeTab == "email-logs" && "active"}`} onClick={handleTabChange} data-name="email-logs">Events</h4>
            </div>
            <div id="pi-l-content">
                <div style={{ display: activeTab == "discharged" ? "block" : "none" }}>
                    <PatientListV2 screenSize={screenSize} etList={etList} cetList={cetList} getSuggestedPrograms={getSuggestedPrograms} SetModalProperties={SetModalProperties} />
                </div>

                <div style={{ display: activeTab == "email-logs" ? "block" : "none" }}>
                    <PatientEmailLogs screenSize={screenSize} etList={etList} cetList={cetList} getSuggestedPrograms={getSuggestedPrograms} SetModalProperties={SetModalProperties} />
                </div>

            </div>
        </div>
    );
}

export default PIList;